{
  "internalPortal": {
    "pages": {
      "globalAudits": {
        "title": "Audits",
        "subtitle": "View and filter audits across all organizations"
      }
    },
    "components": {
      "audits": {
        "title": "Audits",
        "newAudit": "New audit",
        "actions": {
          "displayAuditsAcrossSubsidiaries": "Display audits across subsidiaries"
        },
        "filters": {
          "locationsName": "Locations name",
          "typePlaceholder": "Type"
        },
        "table": {
          "pastDueTooltip": "Past due",
          "locationAssignedTooltip": "Location \"{{locationName}}\" is assigned to this audit",
          "invoicesAttachedCount_one": "{{count}} invoice",
          "invoicesAttachedCount_other": "{{count}} invoices",
          "actions": {
            "copy": "Copy"
          },
          "salesforceSourceTooltip": {
            "parentAudit": "Migrated from Salesforce: created from parent audit {{parentAudit}}.",
            "vendorSplit": "Migrated from Salesforce: created from parent audit {{parentAudit}} as a vendor split.",
            "subaudit": "Migrated from Salesforce: created from parent audit {{parentAudit}}, support audit {{supportAudit}}."
          },
          "filters": {
            "migratedFromSalesforce": "Migrated from Salesforce",
            "createdInPortal": "Created in portal",
            "migrationSource": "Migration source"
          },
          "columns": {
            "name": "Name",
            "status": "Status",
            "salesforceSource": "Salesforce source",
            "parentAudit": "Parent audit",
            "spendCategory": "Spend category",
            "stage": "Stage",
            "vendors": "Vendors",
            "includedLocations": "Included locations",
            "dueDate": "Due date",
            "created": "Created",
            "baselineSpend": "Baseline spend",
            "baselineSpendTooltip": "Reference spend used to measure savings for this audit.",
            "sibContractTerms": "SIB Contract terms",
            "invoicesAttached": "Invoices attached",
            "subsidiaryOrganizationName": "Subsidiary organization name",
            "organization": "Organization",
            "creator": "Creator",
            "assignedTeam": "Assigned team",
            "owner": "Owner"
          }
        },
        "noData": {
          "withFilters": {
            "title": "No audits match your filters",
            "description": "Try adjusting your filters to find what you're looking for"
          },
          "withoutFilters": {
            "title": "No audits found",
            "description": "No audits found for this organization."
          }
        },
        "auditForm": {
          "title": "Create new audit",
          "backNavigationWarning": "Please note that any changes made to a completed step may affect the following steps and require you to complete them again.",
          "fields": {
            "name": "Audit name",
            "spendCategory": "Spend category",
            "dueDate": "Due date",
            "vendor": "Vendor",
            "vendorContact": "Vendor POC",
            "team": "SIB Team",
            "owner": "Owner"
          },
          "placeholders": {
            "name": "Automatically generated audit name / ID",
            "vendorPoc": "Vendor POC section will be added in a later phase."
          },
          "spendAreaFilter": {
            "all": "All"
          },
          "continueDisabledTooltips": {
            "spendCategory": "Select a spend category to continue",
            "contract": "Assign contract to continue"
          },
          "steps": {
            "spendCategory": "Spend category",
            "contract": "Contract",
            "dueDate": "Due date",
            "vendor": "Vendor",
            "vendorPoc": "Vendor POC",
            "team": "SIB Team",
            "owner": "Owner"
          },
          "dueDate": {
            "description": "Due date is inherited from the selected spend category and can't be edited at this stage.\nYou can update it later in the audit edit form or ask an administrator to change it."
          },
          "vendor": {
            "title": "Vendor",
            "description": "Attach the primary vendor for Baseline Spend estimation (or create a new one if needed). Only vendors assigned to the selected spend category and organization are available.",
            "addNew": {
              "title": "Add new"
            },
            "addForm": {
              "title": "Add new vendor",
              "notice": "Please note that this vendor will also be added to the main vendor list.",
              "spendCategory": {
                "label": "Spend category",
                "value": "Selected in audit's creation spend category",
                "tooltip": "A new vendor will be automatically assigned to the selected spend category during audit creation. You can add more spend categories later by editing the vendor in the main vendor list."
              }
            },
            "table": {
              "title": "SIB Vendor list",
              "description": "Select and assign an existing vendor to the audit. You can assign only one vendor for Baseline Spend calculation. The list shows only vendors assigned to the audit's spend category.",
              "breadcrumbs": {
                "creatingAudit": "Creating audit"
              },
              "displayOtherCategories": {
                "label": "Display vendors assigned to other categories",
                "tooltip": "Vendors from other spend categories can be viewed, but they cannot be assigned to this audit."
              },
              "disabledRowTooltip": "You cannot select this vendor. It is assigned to a different spend category than the one selected for this audit.",
              "categoryFilterDisabledTooltip": "Enable \"Display vendors assigned to other categories\" to filter by spend category.",
              "selectVendor": "Select vendor",
              "noData": {
                "title": "No vendors found",
                "description": "No vendors were found for this organization and selected spend category.",
                "descriptionAllVendors": "No vendors were found for this organization."
              },
              "noFilteredResults": {
                "title": "No matching vendors",
                "description": "Try adjusting or clearing filters."
              }
            },
            "attachFromList": {
              "title": "Attach from existing list"
            },
            "actionsDisabled": {
              "tooltip": "Only one vendor can be attached to the audit. Detach  the current vendor to select a different one."
            },
            "placeholder": {
              "title": "No vendors are assigned yet",
              "description": "Attach one from the existing vendors list or create new if needed"
            },
            "attached": {
              "vendorName": "Vendor name",
              "status": "Status",
              "spendCategory": "Spend category",
              "spendCategoryPlaceholder": "Audit's selected spend category",
              "actions": {
                "detach": {
                  "title": "Detach",
                  "tooltip": "Detach this newly created vendor from the audit. It will remain in the main vendor list."
                },
                "delete": {
                  "title": "Delete",
                  "tooltip": "You can delete this newly created vendor and create or attach another one. Deleting it also removes it from the main vendor list. To keep the vendor in the main vendor list, use Detach instead."
                }
              }
            },
            "deleteDialog": {
              "title": "Are you sure you want to delete this vendor",
              "description": "It will also be removed from the main vendor list."
            }
          },
          "vendorContact": {
            "addNew": "Add new",
            "placeholder": {
              "select": "Select point of contact",
              "title": "There are no POCs for this vendor yet.",
              "description": "Create a point of contact (POC) for this vendor or skip this step. You can update the POC later while editing the audit."
            },
            "description": "The vendor's primary point of contact has been selected automatically. You can choose a different contact or create a new one if needed. You can also add additional contacts or update them later when editing the audit.",
            "addForm": {
              "title": "Add new point of contact (POC)",
              "breadcrumbs": {
                "addNewPoc": "Add new POC"
              },
              "notice": "Please note that this vendor POC will also be added to the main vendor list."
            },
            "status": {
              "active": "Active",
              "inactive": "Inactive"
            }
          },
          "team": {
            "placeholder": "Selected team",
            "description": "Select the SIB team responsible for the audit"
          },
          "owner": {
            "description": "Choose the audit owner from the selected team responsible for the audit"
          },
          "contract": {
            "title": "Contract terms",
            "description": "Assign contract terms to the audit or create new one. You can only have one contract tied to audit.",
            "attachFromList": {
              "title": "Attach from existing list",
              "tooltip": "You can only have one contract attached. Detach current contract and select new one."
            },
            "placeholder": {
              "title": "No contract terms are assigned yet",
              "description": "Attach one from the organization's existing SIB contract list"
            },
            "list": {
              "title": "SIB Contract terms list",
              "description": "Please select and assign existing SIB Contract term to the audit. You can only have one contract tied to audit. ",
              "breadcrumbs": {
                "creatingAudit": "Creating audit"
              }
            },
            "attached": {
              "contractName": "Contract name",
              "startDate": "Start date",
              "duration": "Duration",
              "salesEstimatedTcv": "Sales estimated TCV",
              "actions": {
                "detach": "Detach",
                "details": "Details"
              }
            },
            "status": {
              "active": "Active",
              "inactive": "Inactive"
            },
            "periodMonths_one": "{{count}} month",
            "periodMonths_other": "{{count}} months",
            "table": {
              "selectContract": "Select contract",
              "attachDisabled": {
                "inactiveContractTooltip": "Only Admin can attach inactive contracts"
              },
              "expiringSoonTooltip": "This contract expires within 30 days",
              "feeTooltip": {
                "period": "{{start}}–{{end}} mo: {{fee}}%"
              },
              "columns": {
                "name": "Name",
                "status": "Status",
                "fee": "Fee [%]",
                "startDate": "Start date",
                "endDate": "End date",
                "period": "Period",
                "autoRenewal": "Auto renewal",
                "renewalDate": "Renewal date",
                "audits": "Audits",
                "annualContractValue": "Annual contract value",
                "creationDate": "Creation date",
                "salesRepresentative": "Sales Representative"
              }
            }
          }
        }
      }
    },
    "notifications": {
      "auditCreation": {
        "success": "You've successfully created new audit <strong>{{auditName}}</strong>",
        "action": "Check audits details"
      }
    }
  }
}
